export const getPrefix = (value) => (value ? '$' : '')
export const getPrecision = (value) =>
  value !== '0' && value !== null ? '2' : '0'
